import { Redirect } from 'react-router-dom';

import { useParams } from '../navigation/router';
import { activationUserRedirection } from '../../config/signupConfig';

export const ActivationUser = () => {
  const params = useParams<{ userId?: string }>();
  //TODO use route.signupProfile and generatePath fn
  const redirectionPath = `${activationUserRedirection}/${params.userId}`;
  return <Redirect to={redirectionPath} />;
};
